export default "__VITE_ASSET__DtGmfNK5__"